var AuthorizationLevel = /* @__PURE__ */ ((AuthorizationLevel2) => {
  AuthorizationLevel2["Password"] = "1";
  AuthorizationLevel2["TwoFactor"] = "2";
  return AuthorizationLevel2;
})(AuthorizationLevel || {});
export {
  AuthorizationLevel
};
//# sourceMappingURL=types.js.map
